import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { MenuItem } from '../../common';

type DeletePropsType = {
  onClick: () => void;
  disabled?: boolean;
};

export const Delete: React.FC<DeletePropsType> = ({ onClick, disabled }) => {
  const { t } = useTranslation();

  return (
    <MenuItem
      leftSection={
        <FontAwesomeIcon color="var(--mantine-color-red-8)" icon={faTrash} />
      }
      onClick={onClick}
      disabled={disabled}
    >
      {t('FILE_TREE_CONTEXT_MENU.DELETE')}
    </MenuItem>
  );
};
